import React from "react";
import PropTypes from "prop-types";
import { Card, Stack, Typography, Button } from "@mui/material";
import { applyOpacity, parseHtml } from "../../../utils/utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./button-card.scss";

const ButtonCard = ({ cardColor, cardData, customButtonComponent }) => {
    return (
        <Card
            className="division-hover-bubble-container"
            sx={{
                height: "100%",
                borderRadius: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black" || "inherit",
                paddingY: 5,
                paddingX: 3,
                boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.1)",
                "&::before": {
                    right: "-270px",
                    bottom: "-460px",
                    backgroundColor: applyOpacity(cardColor, 0.2)
                }
            }}
        >
            <Stack
                spacing={2}
                direction="column"
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: "80%"
                }}
            >
                {/* Icon */}
                <FontAwesomeIcon icon={cardData.icon} style={{ fontSize: "2.5rem" }} />

                {/* Title */}
                <Typography sx={{ fontWeight: "bold", fontSize: { xs: "medium", lg: "large" } }}>
                    {cardData.title}
                </Typography>

                {/* Description */}
                <div
                    className="info-card-description"
                    style={{ fontSize: { xs: "medium", lg: "large" }, textAlign: "center" }}
                >
                    {parseHtml(cardData.description)}
                </div>

                {/* Button */}
                {customButtonComponent ? (
                    customButtonComponent
                ) : (
                    <Button variant="contained" component={Link} to={cardData?.buttonLink}>
                        {cardData.buttonText}
                    </Button>
                )}
            </Stack>
        </Card>
    );
};

ButtonCard.propTypes = {
    cardColor: PropTypes.string.isRequired,
    cardData: PropTypes.object.isRequired,
    customButtonComponent: PropTypes.node
};

export default ButtonCard;
